import { render, staticRenderFns } from "./PendenciasValidade.vue?vue&type=template&id=60b497f9&"
import script from "./PendenciasValidade.vue?vue&type=script&lang=js&"
export * from "./PendenciasValidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports